import { PreRockSheetList } from './views/pre-rock-sheet-list';

export default {
  list: PreRockSheetList,
  name: 'pre-rock-sheet',
  label: 'Pre-Rock',
  to: '/pre-rock-sheet',
};
